import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AuthService } from '@sc/pas-common';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class GlobalHeaderInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentSession = this.authService.currentSessionValue;
        const authURL = /\/auth\//gi;

        const headerParams = {
            'Ocp-Apim-Trace': 'true'
        };

        if (currentSession && currentSession.jwt && request.url.search(authURL) === -1) {

            headerParams['Authorization'] = `Bearer ${currentSession.jwt}`;
            headerParams['userName'] = currentSession.username;
            headerParams['x-id'] = currentSession.username;

            if (currentSession.branchOffice) {
                headerParams['x-branchOffice'] = currentSession.branchOffice.toString();
            }

            request = request.clone({
                setHeaders: headerParams
            });
        }

        return next.handle(request).pipe(catchError(error => this.handleAuthError(error)));
    }

    private handleAuthError(error: HttpErrorResponse): Observable<any> {
        if (error.status === 401 && !this.router.url.startsWith('/login')) {
            localStorage.clear()
            this.router.navigateByUrl(`/login`);
            return of(error.message);
        }
        return throwError(error);
    }
}
